import { createSlice } from "@reduxjs/toolkit";
import addEditModalityStudy from "@custom/rtk-apis/modalityStudyRegion/addModalityStudy";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addEditModalityStudySlice = createSlice({
  name: "addEditModalityStudySlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEditModalityStudy.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEditModalityStudy.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditModalityStudy.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addEditModalityStudySlice.reducer;
export const { closeModal } = addEditModalityStudySlice.actions;
